import styled from 'styled-components';
export const StyledUL = styled.ul `
  &&& {
    border-top: 1px solid ${({ theme }) => theme.colors.grey07};
    margin: 0;
    padding: 1.5rem;
    list-style: none;
    position: absolute;
    top: 100%;
    width: 21.5rem;
    background-color: ${({ theme }) => theme.colors.white};
    box-sizing: border-box;
    ${({ show }) => `opacity: ${show ? '1' : '0'}`};
    ${({ show }) => `pointer-events: ${show ? 'all' : 'none'}`};
    ${({ openDirection = 'left' }) => `right: ${openDirection === 'right' ? '0px' : 'unset'}`};
    ${({ openDirection = 'right' }) => `left: ${openDirection === 'left' ? '0' : 'unset'}`};
    transition: opacity 0.3s ${({ show }) => (show ? 'ease-in' : 'ease-out')};
    box-shadow: 0 3px 6px 0 ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.26)`},
      inset 0 12px 12px -10px ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.2)`};
  }
`;
